import React, { useState, useEffect } from 'react';
import '../styles/CurrencyExchange.css';

function CurrencyExchange() {
    const [amount, setAmount] = useState('');
    const [fromCurrency, setFromCurrency] = useState('');
    const [toCurrency, setToCurrency] = useState('');
    const [result, setResult] = useState(null);
    const [exchangeRates, setExchangeRates] = useState({});
    const [loading, setLoading] = useState(true);

    // Desired currencies to display
    const desiredCurrencies = ['USD', 'EUR', 'BTC', 'GBP', 'JPY', 'INR'];

    // Replace with your API key
    const API_KEY = 'c53bf4cc88dcae57c9df61f6';
    const BASE_URL = `https://v6.exchangerate-api.com/v6/${API_KEY}/latest/USD`;

    useEffect(() => {
        const fetchExchangeRates = async () => {
            setLoading(true);
            try {
                const response = await fetch(BASE_URL);
                const data = await response.json();

                if (data.result === 'success') {
                    const filteredRates = {};
                    for (const currency of desiredCurrencies) {
                        if (data.conversion_rates[currency]) {
                            filteredRates[currency] = data.conversion_rates[currency];
                        }
                    }

                    setExchangeRates(filteredRates);

                    // Set initial currencies dynamically
                    const currencyKeys = Object.keys(filteredRates);
                    if (currencyKeys.length > 1) {
                        setFromCurrency(currencyKeys[0]); // e.g., USD
                        setToCurrency(currencyKeys[1]);   // e.g., EUR
                    }
                } else {
                    console.error("Error fetching exchange rates:", data['error-type']);
                }
            } catch (error) {
                console.error("Error fetching exchange rates:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchExchangeRates();
    }, []);

    const handleConvert = (e) => {
        e.preventDefault();
        if (fromCurrency === toCurrency) {
            setResult(parseFloat(amount));
            return;
        }
        const rate = exchangeRates[toCurrency];
        if (rate) {
            const converted = parseFloat(amount) * rate;
            setResult(converted);
        } else {
            alert("Exchange rate not available.");
        }
    };

    return (
        <div className="currency-exchange">
            <div className="exchange-container">
                {/* Conversion Form */}
                <div className="exchange-card">
                    <h1>Currency Exchange</h1>
                    {loading ? (
                        <p>Loading exchange rates...</p>
                    ) : (
                        <form onSubmit={handleConvert}>
                            <div className="form-group">
                                <label>Amount</label>
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    placeholder="Enter amount"
                                    required
                                    min="0"
                                    step="0.01"
                                />
                            </div>

                            <div className="currency-selectors">
                                <div className="form-group">
                                    <label>From</label>
                                    <select
                                        value={fromCurrency}
                                        onChange={(e) => setFromCurrency(e.target.value)}
                                    >
                                        {Object.keys(exchangeRates).map(currency => (
                                            <option key={currency} value={currency}>
                                                {currency.toUpperCase()}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <button type="button" className="swap-button" onClick={() => {
                                    setFromCurrency(toCurrency);
                                    setToCurrency(fromCurrency);
                                }}>
                                    ⇄
                                </button>

                                <div className="form-group">
                                    <label>To</label>
                                    <select
                                        value={toCurrency}
                                        onChange={(e) => setToCurrency(e.target.value)}
                                    >
                                        {Object.keys(exchangeRates).map(currency => (
                                            <option key={currency} value={currency}>
                                                {currency.toUpperCase()}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <button type="submit" className="convert-btn">Convert</button>
                        </form>
                    )}
                </div>
                {/* Result Section */}
                {result !== null && (
                    <div className="result">
                        <h2>Result</h2>
                        <div className="conversion-result">
                            <p>{parseFloat(amount).toFixed(2)} {fromCurrency} =</p>
                            <p className="converted-amount">{result.toFixed(2)} {toCurrency}</p>
                        </div>
                        {exchangeRates[toCurrency] && (
                            <p className="rate-info">
                                1 {fromCurrency} = {exchangeRates[toCurrency].toFixed(4)} {toCurrency}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CurrencyExchange;
